import React from 'react';
import { PrivacyPolicyContainer } from '../PrivacyPolicy/PrivacyStyles.styles';

const Termination = () => {
  return (
    <PrivacyPolicyContainer>
      <h3>Account Suspension and Termination</h3>

      <p>
        Yoda Safety Services reserves the right to restrict, suspend, terminate,
        or delete an account where we reasonably determine that continued access
        to the platform or services is inappropriate, presents a risk to the
        platform or its users, or is otherwise inconsistent with the operation
        of our services.
      </p>

      <p>
        This right may be exercised with or without prior notice where
        reasonably appropriate in the circumstances. Yoda Safety Services also
        reserves the right, to the extent permitted by applicable law and any
        applicable agreement, to discontinue providing platform access to a
        particular individual.
      </p>

      <p>
        Reasons for suspension, termination, or account deletion may include:
      </p>

      <ul>
        <li>
          Violating these Terms & Conditions or applicable laws or regulations.
        </li>
        ```
        <li>
          Engaging in fraudulent, unlawful, threatening, abusive, or otherwise
          inappropriate activity through or in connection with the platform.
        </li>
        <li>
          Sharing account credentials or providing unauthorized access to the
          platform.
        </li>
        <li>
          Falsifying, altering, manipulating, or misusing training records,
          certificates, quiz or assessment results, form entries, or other
          platform records.
        </li>
        <li>
          Attempting to access information, accounts, company resources, forms,
          manuals, systems, or platform functionality without authorization.
        </li>
        <li>
          Interfering with the security, integrity, availability, or operation
          of the platform.
        </li>
        <li>
          Misusing Yoda Safety Services content, services, or intellectual
          property.
        </li>
        <li>
          Failing to make required payments for services where continued access
          is dependent on payment.
        </li>
        <li>
          Conduct or circumstances that Yoda Safety Services reasonably
          determines justify restricting or discontinuing the individual&apos;s
          access to the platform or services.
        </li>
        ```
      </ul>

      <p>
        The examples above are not exhaustive. Yoda Safety Services may
        restrict, suspend, terminate, or delete an account for other reasonable
        grounds where necessary to protect the platform, our services, Yoda
        Safety Services, our users, or other individuals or organizations.
      </p>

      <h4>User-Requested Account Closure</h4>

      <p>
        Users may request closure of their account by contacting Yoda Safety
        Services at{' '}
        <a href="mailto:yodasafetyservices1@outlook.com">
          yodasafetyservices1@outlook.com
        </a>
        . Account closure may be subject to requirements associated with company
        accounts, active services, training records, subscriptions, or other
        applicable agreements.
      </p>

      <h4>Consequences of Suspension or Termination</h4>

      <p>
        Depending on the circumstances, suspension or termination may result in
        the loss of access to some or all platform features, including courses,
        assessments, forms, manuals, company resources, subscriptions, training
        records, certificates, or other services available through the affected
        account.
      </p>

      <p>
        Termination or deletion of an account does not automatically require
        Yoda Safety Services to delete all information or records associated
        with that account. Certain training records, transaction records, form
        entries, company records, security records, or other information may be
        retained where reasonably necessary for legal, regulatory, contractual,
        security, record-keeping, dispute resolution, or legitimate business
        purposes, as described in our Privacy Policy.
      </p>

      <p>
        Account suspension, termination, or deletion does not create a right to
        a refund where the applicable purchase or service is non-refundable,
        except where a refund is required by applicable law or expressly
        provided under applicable purchase terms or another agreement.
      </p>

      <h4>Continued Restrictions</h4>

      <p>
        An individual whose account has been terminated or deleted by Yoda
        Safety Services may not create or use another account to circumvent the
        termination, or access the platform through another user&apos;s,
        company&apos;s, or organization&apos;s account, unless Yoda Safety
        Services has expressly authorized renewed access.
      </p>
    </PrivacyPolicyContainer>
  );
};

export default Termination;
